export const en = {
    'back-to-creatives': 'Back to My Creatives',
    'back-to-ideas': 'Back to ideas for creatives',
    'back-to-presets': 'Back to templates',
    cancel: 'Cancel',
    create: 'Create',
    'create-error': 'Error adding the creative. Please try again later.',
    'create-video-error': "Couldn't add the video creative. Try again later.",
    'crop-revert-confirm-message': 'Cancel changes to image?',
    'fetch-error': 'Error retrieving data. Please try again later.',
    'fetch-video-error': "Couldn't get the video creative data. Try again later.",
    'overlay-name': 'New banner',
    'parameters-errors': "Couldn't create the creative. The following elements have errors: {errors}",
    'preview-title': 'Preview',
    'to-creatives': 'Back to image ads list',
    'video-ad-name': 'New video creative',
    'video-addition-name': 'New video extension',
    'video-cpm-audio-name': 'New audio creative'
};
